import { useTranslation } from 'react-i18next'
import { RouteChildrenProps } from 'react-router-dom'

import { PreparationsForm } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import useSaveOnBack from 'hooks/useSaveOnBack'

import usePage from '../../hooks/usePage'

const PreparationsPage: React.FC<RouteChildrenProps> = () => {
  const { onSubmit, onBack, initialValues = {} } = usePage()
  const formikRef = useSaveOnBack({ onBack })
  const { t } = useTranslation()

  return (
    <PageLayout title={t('category.additional_details')} subtitle={t('subcategory.in_preparation')}>
      <PreparationsForm initialValues={initialValues} onSubmit={onSubmit} innerRef={formikRef} loading={false} />
    </PageLayout>
  )
}

export default PreparationsPage
